import { Icons } from '@components/Icons/Icons';
import { ProgressBar } from '@components/ProgressBar/ProgressBar';

const EXPRESS_THRESHOLD = 3.5; // in kg
const CLASSES = 'text-xs text-center flex flex-col gap-1 mx-1 pt-1';

export function CartWeightIndicator({ weight }: { weight: number }) {
  const REMAINING_WEIGHT_FOR_EXPRESS = EXPRESS_THRESHOLD - weight;

  if (REMAINING_WEIGHT_FOR_EXPRESS <= 0.07) {
    return null;
  }

  // Single bar
  if (
    REMAINING_WEIGHT_FOR_EXPRESS < 0.2 &&
    REMAINING_WEIGHT_FOR_EXPRESS > 0.07
  ) {
    return (
      <div className={CLASSES}>
        Add a protein bar to your cart and still receive express shipping!
        <ProgressBar
          percentage={(weight / EXPRESS_THRESHOLD) * 100}
          Icon={Icons.Plane}
        />
      </div>
    );
  }

  // Capsules
  if (REMAINING_WEIGHT_FOR_EXPRESS >= 0.2 && REMAINING_WEIGHT_FOR_EXPRESS < 1) {
    return (
      <div className={CLASSES}>
        Add capsules to your cart and still receive express shipping!
        <ProgressBar
          percentage={(weight / EXPRESS_THRESHOLD) * 100}
          Icon={Icons.Plane}
        />
      </div>
    );
  }

  return (
    <div className={CLASSES}>
      You can add {REMAINING_WEIGHT_FOR_EXPRESS.toFixed(2)} kg to your cart and
      still receive express shipping!
      <ProgressBar
        percentage={(weight / EXPRESS_THRESHOLD) * 100}
        Icon={Icons.Plane}
      />
    </div>
  );
}
